import React from 'react';
import { attachmentKindFor, formatBytes } from './attachmentMeta';

type Props = {
	name: string;
	mimeType: string;
	sizeBytes?: number;
};

// The non-image attachment chip. Shared by the composer (ChatInput, pre-send)
// and the message history (MessageBlock) so an uploaded file looks identical in
// both places — one source of truth for both the logic and the markup.
const AttachmentChip = ({ name, mimeType, sizeBytes }: Props) => {
	const { className, label } = attachmentKindFor(mimeType, name);
	const size = formatBytes(sizeBytes);
	return (
		<div className="pr-msg-attachment" title={name}>
			<span className={`ws-ctx-thumb ${className}`}>{label}</span>
			<div className="pr-msg-attachment-info">
				<span className="pr-msg-attachment-name">{name}</span>
				{size && <span className="pr-msg-attachment-size">{size}</span>}
			</div>
		</div>
	);
};

export default AttachmentChip;
